import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import { CONTACT_URL, PRICING_URL } from "@/lib/brand";

export function VisionBadge() {
  return (
    <a href={PRICING_URL} data-testid="included-in-vision-badge"
      className="inline-flex items-center gap-2 self-start bg-safety text-white px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] hover:bg-ink-900 transition-colors">
      Included in Vision <ArrowUpRight size={12} weight="bold" />
    </a>
  );
}

export function CtaRow({ testPrefix, dark, readinessLabel = "Book an AI readiness assessment" }) {
  const outline = dark
    ? "border-white/40 text-white bg-transparent hover:bg-white hover:text-ink-900"
    : "border-ink-900 hover:bg-ink-900 hover:text-white";
  return (
    <div className="flex flex-wrap gap-3">
      <a href={CONTACT_URL}>
        <Button data-testid={`${testPrefix}-cta-pilot`} size="lg" className="rounded-none bg-safety hover:bg-safety-hover text-white h-12 px-6 text-sm font-semibold">
          Request a paid pilot <ArrowRight size={16} className="ml-2" weight="bold" />
        </Button>
      </a>
      <a href={CONTACT_URL}>
        <Button data-testid={`${testPrefix}-cta-evaluation`} variant="outline" size="lg" className={`rounded-none h-12 px-6 text-sm font-semibold ${outline}`}>
          Book a $1,500 compliance evaluation
        </Button>
      </a>
      <a href={CONTACT_URL}>
        <Button data-testid={`${testPrefix}-cta-readiness`} variant="outline" size="lg" className={`rounded-none h-12 px-6 text-sm font-semibold ${outline}`}>
          {readinessLabel}
        </Button>
      </a>
    </div>
  );
}
